/** WCAG 2.x colour contrast — shared by the API (validation) and the web client (live preview). */

export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

function channel(c: number): number {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
}

export function relativeLuminance(hex: string): number {
  const n = Number.parseInt(hex.slice(1), 16);
  return 0.2126 * channel((n >> 16) & 255) + 0.7152 * channel((n >> 8) & 255) + 0.0722 * channel(n & 255);
}

export function contrastRatio(a: string, b: string): number {
  const [hi, lo] = [relativeLuminance(a), relativeLuminance(b)].sort((x, y) => y - x) as [number, number];
  return Math.round(((hi + 0.05) / (lo + 0.05)) * 100) / 100;
}

/** Brand colours carry white button text, so they must reach AA for normal text against white. */
export const MIN_BUTTON_CONTRAST = 4.5;

/** Personal accent presets (UI prefs). Each is validated ≥ 4.5:1 against white in tests. */
export const ACCENT_COLORS = {
  blue: '#2f5bea',
  teal: '#0f766e',
  green: '#15803d',
  violet: '#6d28d9',
  rose: '#be123c',
  orange: '#c2410c',
} as const;
